import { render } from "./TaskSelection.vue?vue&type=template&id=192187a9&scoped=true&ts=true"
import script from "./TaskSelection.vue?vue&type=script&lang=ts"
export * from "./TaskSelection.vue?vue&type=script&lang=ts"

import "./TaskSelection.vue?vue&type=style&index=0&id=192187a9&lang=scss&scoped=true"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192187a9"]])

export default __exports__